import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEdit } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useGetCategoryListQuery } from "../../Services/CategoryAPI";
import { useGetBrandListQuery } from "../../Services/BrandsAPI";
import { useGetProductByIdQuery } from "../../Services/ProductAPI";
import { useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";

function AddProduct() {
    const { id } = useParams();
    // State variables
    const [productCode, setProductCode] = useState("");
    const [productName, setProductName] = useState("");
    const [productImage, setProductImage] = useState(null);
    const [productImage1, setProductImage1] = useState(null);
    const [productImage2, setProductImage2] = useState(null);
    const [productImage3, setProductImage3] = useState(null);
    const [productPrice, setProductPrice] = useState("");
    const [sellingPrice, setSellingPrice] = useState("");
    const [additionalInfo, setAdditionalInfo] = useState("");
    const [productBrand, setProductBrand] = useState("");
    const [category, setcategory] = useState("");
    const [description, setDescription] = useState("");
    const [detailedDescription, setDetailedDescription] = useState("");
    const [isFeatured, setIsFeatured] = useState("No");
    const [isNew, setIsNew] = useState(0);
    const [isHot, setIsHot] = useState(0);


    // API Hooks
    const { data: parentCategories } = useGetCategoryListQuery();
    const { data: brandList } = useGetBrandListQuery();

    const { data: productDetail, isLoading: loadingContent, error, refetch: refetchProductDetail } = useGetProductByIdQuery(id);

    useEffect(() => {
        refetchProductDetail();
    },[refetchProductDetail])

    useEffect(() => {
        if (productDetail) {
            setProductCode(productDetail?.data?.product_code || "");
            setProductName(productDetail?.data?.product_name || "");
            setProductPrice(productDetail?.data?.product_price || "");
            setSellingPrice(productDetail?.data?.selling_price || "");
            setDescription(productDetail?.data?.description || "");
            setAdditionalInfo(productDetail?.data?.additional_info || "")
            setDetailedDescription(productDetail?.data?.detailed_description || "");
            setIsFeatured(productDetail?.data?.is_featured || "No");
            setIsNew(productDetail?.data?.is_new || 0);
            setIsHot(productDetail?.data?.is_hot || 0);
            setcategory(productDetail?.data?.category_id || "");
            setProductBrand(productDetail?.data?.brand_id || "");
        }

    }, [productDetail])

    useEffect(() => {
        console.log(productImage);
        console.log(productImage1);
        console.log(productImage2);
        console.log(productImage3);
    }, [productImage, productImage1, productImage2, productImage3])


    const handleEditorChange = (content) => {
        setDetailedDescription(content); // Correct way to capture content
    };

    if (loadingContent) return <div class="loader"></div>;
    if (error) return <p>Failed to load Data</p>;

    return (
        <div>
            <h3>Add Product</h3>
            <div className="breadcrum mb-4">
                <p>
                    <Link to="/products"><span>Products</span></Link>
                    <FontAwesomeIcon icon={faAngleRight} className="mx-2" />
                    <span className="active-link">View</span>
                </p>
            </div>

            <div className="text-end">
                <Link to={`/edit-products/${id}`}><button className="btn-primary mb-4"><FontAwesomeIcon
                    icon={faEdit}
                    className="text-primary mx-2"
                />Edit</button></Link>
            </div>

            <div className="content-wrapper">
                <form encType="multipart/form-data">
                    <div className="row">
                        {/* Product Name */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Product Name"
                                    value={productName}
                                    onChange={(e) => setProductName(e.target.value)}
                                />
                               
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Code</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Product Code"
                                    value={productCode}
                                    onChange={(e) => setProductCode(e.target.value)}
                                />
                                
                            </div>
                        </div>




                        {/* Product Price */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Price</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Product Price"
                                    value={productPrice}
                                    onChange={(e) => setProductPrice(e.target.value)}
                                />
                               
                            </div>
                        </div>

                        {/* Selling Price */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Selling Price</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Selling Price"
                                    value={sellingPrice}
                                    onChange={(e) => setSellingPrice(e.target.value)}
                                />
                            </div>
                        </div>

                        {/* Parent Category */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Select Category</label>
                                <select
                                    className="form-control"
                                    value={category}
                                    onChange={(e) => setcategory(e.target.value)}
                                >
                                    <option value="">Select Category</option>
                                    {parentCategories?.data?.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.category_name}
                                        </option>
                                    ))}
                                </select>
                               
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Select Brand</label>
                                <select
                                    className="form-control"
                                    value={productBrand}
                                    onChange={(e) => setProductBrand(e.target.value)}
                                >
                                    <option value="">Select Brand</option>
                                    {brandList?.brands?.map((category) => (
                                        <option key={category.id} value={category.id}>
                                            {category.name}
                                        </option>
                                    ))}
                                </select>
                                
                            </div>
                        </div>


                        {/* Description */}
                        <div className="col-md-12">
                            <div className="mb-4 text-start">
                                <label className="form-label">Description</label>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                />
                                
                            </div>
                        </div>
                        {/* Product Image */}
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setProductImage(e.target.files[0])}
                                />
                                <img src={productDetail?.data?.product_main_image_url_large} width={200} height={200} className="mt-4" alt="img"/>
                            </div>
                        </div>

                    </div>

                    <h5 className="mb-3 mt-4">Add other Images</h5>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Image 2</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setProductImage1(e.target.files[0])}
                                />
                                {productDetail?.data?.product_image_two_url && <img src={productDetail?.data?.product_image_two_url} width={200} height={200} className="mt-4" alt="img" />}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Image 3</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setProductImage2(e.target.files[0])}
                                />
                                {productDetail?.data?.product_image_three_url && <img src={productDetail?.data?.product_image_three_url} width={200} height={200} className="mt-4" alt="img"/>}
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="mb-4 text-start">
                                <label className="form-label">Product Image 4</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={(e) => setProductImage3(e.target.files[0])}
                                />
                                {productDetail?.data?.product_image_four_url && <img src={productDetail?.data?.product_image_four_url} width={200} height={200} className="mt-4" alt="img"/>}
                            </div>
                        </div>

                    </div>

                    <h5 className="mb-3 mt-4">Additional Information</h5>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="mb-4 text-start">
                                <label className="form-label">Additional Info</label>
                                <textarea
                                    rows={4}
                                    className="form-control"
                                    value={additionalInfo}
                                    onChange={(e) => setAdditionalInfo(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="mb-4 text-start">
                                <label className="form-label">Additional Info</label>
                                <Editor
                                    apiKey={process.env.REACT_APP_TINYMCE_KEY}
                                    value={detailedDescription}
                                    onEditorChange={handleEditorChange}
                                    init={{
                                        height: 300,
                                        menubar: false,
                                        plugins: [
                                            "advlist",
                                            "autolink",
                                            "lists",
                                            "link",
                                            "preview",
                                            "searchreplace",
                                            "wordcount",
                                        ],
                                        toolbar:
                                            "undo redo | blocks | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link",
                                        content_style:
                                            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                        paste_data_images: true,
                                        paste_as_text: false,
                                        paste_enable_default_filters: true,
                                        removed_menuitems: "paste",
                                    }}
                                />
                            </div>
                        </div>


                        <div className="col-md-3 col-sm-12 col-lg-3">
                            <div className="mb-4 text-start d-flex">

                                <input
                                    type="checkbox"
                                    checked={isFeatured === "Yes"}
                                    name="isFeatured"
                                    onChange={(e) => setIsFeatured(e.target.checked ? "Yes" : "No")}
                                /><label htmlFor="description" className="form-label w-100">Is Featured</label>
                            </div>
                        </div>


                        <div className="col-md-3 col-sm-12 col-lg-3">
                            <div className="mb-4 text-start d-flex">

                                <input
                                    type="checkbox"
                                    checked={isNew === 1}
                                    name="isNew"
                                    onChange={(e) => setIsNew(e.target.checked ? 1 : 0)}
                                /><label htmlFor="description" className="form-label w-100">Is New</label>
                            </div>
                        </div>

                        <div className="col-md-3 col-sm-12 col-lg-3">
                            <div className="mb-4 text-start d-flex">

                                <input
                                    type="checkbox"
                                    checked={isHot === 1}
                                    name="isHot"
                                    onChange={(e) => setIsHot(e.target.checked ? 1 : 0)}
                                /><label htmlFor="description" className="form-label w-100">Is Hot</label>
                            </div>
                        </div>

                    </div>
                  
                </form>
            </div>
        </div>
    );
}

export default AddProduct;
